import { useState } from "react";
import { generateInputs } from "./SmsInput";

export const useInputLogic = (inputsAmount: number) => {
  const [otpInputs, setOtpInputs] = useState<string[]>(
    generateInputs(inputsAmount, "string")
  );

  const inputChange = (e: any, index: number) => {
    const { value, nextSibling, previousSibling } = e.target;

    setOtpInputs((prevInputs) => {
      const newInputs = [...prevInputs];
      newInputs[index] = value;
      return newInputs;
    });

    // Если значение есть и впереди есть инпут мы переходим на него
    if (!!value && nextSibling) {
      nextSibling.select();
      //   Если мы удалили значение и сзади есть инпут мы переходим на него
    } else if (!!previousSibling && !value) {
      previousSibling.select();
    }
  };

  return { otpInputs, inputChange, setOtpInputs };
};
